(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eff-3d-viewer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const axes = ['width', 'depth', 'height'];

    function initializeViewer(section) {
      if (section.dataset.efforest3dReady === 'true') return;
      section.dataset.efforest3dReady = 'true';

      const viewer = section.querySelector('model-viewer');
      const panel = section.querySelector('[data-measurement-panel]');
      const svg = section.querySelector('[data-measurement-lines]');
      const toggle = section.querySelector('[data-dimension-toggle]');
      const close = section.querySelector('[data-dimension-close]');
      const showAll = section.querySelector('[data-show-all]');
      const styleToggle = section.querySelector('[data-style-toggle]');
      const stylePopover = section.querySelector('[data-style-popover]');
      const labels = [...section.querySelectorAll('.efforest-3d__measurement-label[data-axis]')];
      const axisButtons = [...section.querySelectorAll('.efforest-3d__axis-button[data-axis]')];
      const styleOptions = [...section.querySelectorAll('.efforest-3d__style-option[data-value]')];
      if (!viewer || !panel || !svg || !toggle) return;

      let activeAxis = 'width';
      let dimensionsVisible = true;
      const settings = { dock: 'bottom', size: 'compact', theme: 'aurora' };
      const storageKey = `efforest-dimensions-${section.dataset.modelId || 'model'}-v1`;

      try {
        Object.assign(settings, JSON.parse(localStorage.getItem(storageKey) || '{}'));
      } catch (error) {
        // Storage can be unavailable in private browsing.
      }

      function hotspot(name) {
        if (typeof viewer.queryHotspot === 'function') {
          return viewer.queryHotspot(`hotspot-${name}`);
        }

        const element = viewer.querySelector(`[slot="hotspot-${name}"]`);
        if (!element) return null;
        const viewerRect = viewer.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        return {
          canvasPosition: {
            x: elementRect.left - viewerRect.left + elementRect.width / 2,
            y: elementRect.top - viewerRect.top + elementRect.height / 2
          }
        };
      }

      function setLine(line, from, to) {
        if (!line || !from || !to) return;
        line.setAttribute('x1', from.canvasPosition.x);
        line.setAttribute('y1', from.canvasPosition.y);
        line.setAttribute('x2', to.canvasPosition.x);
        line.setAttribute('y2', to.canvasPosition.y);
      }

      function drawAxis(axis) {
        const lines = svg.querySelectorAll(`g[data-axis="${axis}"] line`);
        setLine(lines[0], hotspot(`${axis}-edge-start`), hotspot(`${axis}-line-start`));
        setLine(lines[1], hotspot(`${axis}-line-start`), hotspot(`${axis}-line-end`));
        setLine(lines[2], hotspot(`${axis}-line-end`), hotspot(`${axis}-edge-end`));
      }

      function clamp(value, minimum, maximum) {
        return Math.min(Math.max(value, minimum), maximum);
      }

      function overlaps(first, second, gap = 8) {
        return !(
          first.right + gap <= second.left ||
          first.left >= second.right + gap ||
          first.bottom + gap <= second.top ||
          first.top >= second.bottom + gap
        );
      }

      function productBounds() {
        const corners = ['bbox-lbf', 'bbox-rbf', 'bbox-ltf', 'bbox-rtf', 'bbox-lbb', 'bbox-rbb', 'bbox-ltb', 'bbox-rtb']
          .map(hotspot)
          .filter(Boolean)
          .map((item) => item.canvasPosition);
        if (corners.length !== 8) return null;
        const bounds = {
          left: Math.min(...corners.map((item) => item.x)),
          right: Math.max(...corners.map((item) => item.x)),
          top: Math.min(...corners.map((item) => item.y)),
          bottom: Math.max(...corners.map((item) => item.y))
        };
        if (bounds.right - bounds.left < 20 || bounds.bottom - bounds.top < 20) return null;
        return bounds;
      }

      function labelRectangle(center, width, height) {
        return {
          left: center.x - width / 2,
          right: center.x + width / 2,
          top: center.y - height / 2,
          bottom: center.y + height / 2
        };
      }

      function layoutLabels() {
        const product = productBounds();
        if (!product || !dimensionsVisible) return;

        const padding = 10;
        const gap = 12;
        const safeTop = 72;
        const safeBottom = panel.dataset.dock === 'bottom' ? panel.offsetTop - padding : viewer.clientHeight - padding;
        const placed = [];

        if (panel.dataset.dock !== 'bottom') {
          const viewerRect = viewer.getBoundingClientRect();
          const panelRect = panel.getBoundingClientRect();
          placed.push({
            left: panelRect.left - viewerRect.left,
            right: panelRect.right - viewerRect.left,
            top: panelRect.top - viewerRect.top,
            bottom: panelRect.bottom - viewerRect.top
          });
        }

        labels
          .filter((label) => !label.classList.contains('is-hidden'))
          .sort((first, second) => Number(second.dataset.axis === activeAxis) - Number(first.dataset.axis === activeAxis))
          .forEach((label) => {
            const axis = label.dataset.axis;
            const start = hotspot(`${axis}-line-start`);
            const end = hotspot(`${axis}-line-end`);
            if (!start || !end) return;

            const midpoint = {
              x: (start.canvasPosition.x + end.canvasPosition.x) / 2,
              y: (start.canvasPosition.y + end.canvasPosition.y) / 2
            };
            const width = label.offsetWidth;
            const height = label.offsetHeight;
            const candidates = [
              { x: midpoint.x, y: product.bottom + gap + height / 2 },
              { x: product.right + gap + width / 2, y: midpoint.y },
              { x: midpoint.x, y: product.top - gap - height / 2 },
              { x: product.left - gap - width / 2, y: midpoint.y },
              { x: midpoint.x, y: safeBottom - height / 2 }
            ]
              .map((center) => ({
                center: {
                  x: clamp(center.x, padding + width / 2, viewer.clientWidth - padding - width / 2),
                  y: clamp(center.y, safeTop + height / 2, safeBottom - height / 2)
                }
              }))
              .map((candidate) => ({
                ...candidate,
                rect: labelRectangle(candidate.center, width, height),
                distance: Math.hypot(candidate.center.x - midpoint.x, candidate.center.y - midpoint.y)
              }))
              .sort((first, second) => first.distance - second.distance);

            const chosen = candidates.find(({ rect }) =>
              rect.left >= padding &&
              rect.right <= viewer.clientWidth - padding &&
              rect.top >= safeTop &&
              rect.bottom <= safeBottom &&
              !overlaps(rect, product, 0) &&
              placed.every((occupied) => !overlaps(rect, occupied))
            ) || candidates[candidates.length - 1];

            if (!chosen) return;
            label.style.left = `${chosen.center.x}px`;
            label.style.top = `${chosen.center.y}px`;
            label.classList.add('is-positioned');
            placed.push(chosen.rect);

            const leader = svg.querySelector(`g[data-axis="${axis}"] .label-leader`);
            if (leader) {
              const labelEdge = {
                x: clamp(midpoint.x, chosen.rect.left, chosen.rect.right),
                y: clamp(midpoint.y, chosen.rect.top, chosen.rect.bottom)
              };
              setLine(leader, { canvasPosition: midpoint }, { canvasPosition: labelEdge });
            }
          });
      }

      function renderLines() {
        axes.forEach(drawAxis);
        layoutLabels();
      }

      function renderWhenReady(attempt = 0) {
        renderLines();
        if (!section.querySelector('.efforest-3d__measurement-label.is-positioned') && attempt < 120) {
          requestAnimationFrame(() => renderWhenReady(attempt + 1));
        }
      }

      function applySettings() {
        panel.dataset.dock = settings.dock;
        panel.dataset.size = settings.size;
        viewer.dataset.theme = settings.theme;
        styleOptions.forEach((option) => {
          const setting = option.parentElement.dataset.setting;
          option.setAttribute('aria-pressed', String(settings[setting] === option.dataset.value));
        });
        try {
          localStorage.setItem(storageKey, JSON.stringify(settings));
        } catch (error) {
          // Keep the current choice even when storage is unavailable.
        }
        requestAnimationFrame(renderLines);
      }

      function updateVisibility() {
        const allVisible = showAll && showAll.checked;
        toggle.setAttribute('aria-pressed', String(dimensionsVisible));
        toggle.textContent = dimensionsVisible ? toggle.dataset.hideLabel : toggle.dataset.showLabel;
        panel.classList.toggle('is-hidden', !dimensionsVisible);
        svg.classList.toggle('is-hidden', !dimensionsVisible);

        axisButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.axis === activeAxis));
        });

        axes.forEach((axis) => {
          const visible = dimensionsVisible && (axis === activeAxis || allVisible);
          const active = axis === activeAxis;
          const group = svg.querySelector(`g[data-axis="${axis}"]`);
          if (!group) return;
          group.querySelectorAll('line').forEach((line) => {
            line.classList.toggle('is-hidden', !visible);
            line.classList.toggle('is-active', active);
            if (line.classList.contains('dimension')) {
              const marker = active ? panel.dataset.markerActive : panel.dataset.markerInactive;
              line.setAttribute('marker-start', `url(#${marker})`);
              line.setAttribute('marker-end', `url(#${marker})`);
            }
          });
        });

        labels.forEach((label) => {
          const visible = dimensionsVisible && (label.dataset.axis === activeAxis || allVisible);
          label.classList.toggle('is-hidden', !visible);
          label.classList.toggle('is-active', label.dataset.axis === activeAxis);
        });
        requestAnimationFrame(renderLines);
      }

      toggle.addEventListener('click', () => {
        dimensionsVisible = !dimensionsVisible;
        updateVisibility();
      });
      close?.addEventListener('click', () => {
        dimensionsVisible = false;
        updateVisibility();
      });
      showAll?.addEventListener('change', updateVisibility);
      axisButtons.forEach((button) => {
        button.addEventListener('click', () => {
          activeAxis = button.dataset.axis;
          if (showAll) showAll.checked = false;
          updateVisibility();
        });
      });
      styleToggle?.addEventListener('click', () => {
        const willOpen = stylePopover.hidden;
        stylePopover.hidden = !willOpen;
        styleToggle.setAttribute('aria-expanded', String(willOpen));
      });
      styleOptions.forEach((option) => {
        option.addEventListener('click', () => {
          const setting = option.parentElement.dataset.setting;
          settings[setting] = option.dataset.value;
          applySettings();
        });
      });
      section.addEventListener('click', (event) => {
        if (stylePopover && !stylePopover.hidden && !stylePopover.contains(event.target) && !styleToggle.contains(event.target)) {
          stylePopover.hidden = true;
          styleToggle.setAttribute('aria-expanded', 'false');
        }
      });
      viewer.addEventListener('load', renderWhenReady);
      viewer.addEventListener('camera-change', renderLines);
      window.addEventListener('resize', renderLines);
      applySettings();
      updateVisibility();
      requestAnimationFrame(renderWhenReady);
    }

    function initializeAll(root = document) {
      root.querySelectorAll('[data-efforest-3d]').forEach(initializeViewer);
    }

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
